import React from 'react'
import OnlyCoverView from './OnlyCoverView'
import StoryContentView from './StoryContentView'
import { KTColors } from '../../Constants/KTColors'
import { heightPercentageToDP, widthPercentageToDP } from '../../../Utils/ResponsiveScreen'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'

const styles = {
  progressBar: {
    height: heightPercentageToDP('0.3%'),
    borderRadius: 5,
    marginLeft: 3,
    marginRight: 3,
    marginBottom: heightPercentageToDP('90%'),
  },
  nextButton: {
    width: widthPercentageToDP('20%'),
    alignItems: 'flex-end',
  },
  arrowStyle: {
    marginTop: heightPercentageToDP('4%'),
    marginBottom: heightPercentageToDP('12%'),
    backgroundColor: KTColors.black10,
    borderRadius: 50,
  },
  prevButton: {
    width: widthPercentageToDP('20%'),
    alignItems: 'flex-start',
  },
}

class SlideShowView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0,
    }
  }
  renderContent = (item) => {
    const { content, contentVisibleLang } = this.props
    switch (item.pageType) {
      case 'Story':
        return (
          <div>
            <StoryContentView
              content={item}
              isPausedVideo={this.props.isPausedVideo}
              title={item.storyDetails[`storyTitle_${contentVisibleLang}`]}
              cardDescription={item.storyDetails[`storyCardDescription_${contentVisibleLang}`]}
              cardImages={
                item.storyDetails.storyCardOriginalImages
                  ? item.storyDetails.storyCardOriginalImages
                  : item.storyDetails.storyCardImages
              }
              contentLinkDetails={item.storyDetails.contentLinkDetails}
              contentNewLinkDetails={item.storyDetails.contentNewLinkDetails}
              slideShow={true}
              coverStoryVideoURL={item.storyDetails.coverStoryVideoURL}
            />
          </div>
        )
      case 'CoverStory':
        const { onlyCoverDetails } = item.coverStoryDetails
        return (
          <div style={{ position: 'relative', height: '100%' }}>
            <OnlyCoverView
              content={item}
              slideShow={true}
              onlycoverDetails={onlyCoverDetails}
              coverStoryTitle={onlyCoverDetails[`coverStoryTitle_${contentVisibleLang}`]}
              coverStoryCardDescription={
                onlyCoverDetails[`coverStoryCardDescription_${contentVisibleLang}`]
              }
              coverStoryVideoURL={onlyCoverDetails.coverStoryVideoURL}
              contentNewLinkDetails={onlyCoverDetails.contentNewLinkDetails}
            />
          </div>
        )
      case 'Comment':
        return (
          <div
            style={{
              height: heightPercentageToDP('100%'),
            }}
          >
            <p>Comment Screen</p>
          </div>
        )
      default:
        return null
    }
  }

  componentDidMount() {
    const { slideShowDetails } = this.props.content.contentMetaInfo
    let pages
    pages = slideShowDetails && slideShowDetails.pages
  }

  render() {
    const { slideShowDetails } = this.props.content.contentMetaInfo
    let pages = []
    pages = slideShowDetails && slideShowDetails.pages
    return pages && pages.length ? (
      <Slide
        infinite={false}
        duration={8000}
        autoPlay={true}
        onChange={(oldIndex, newIndex) => {
          this.setState({
            selectedIndex: newIndex,
          })
        }}
      >
        {this.props.content.contentMetaInfo.slideShowDetails.pages.map((item, index) => {
          return (
            <div
              style={{
                height: heightPercentageToDP('100%'),
              }}
              key={index}
            >
              {index == this.state.selectedIndex && this.renderContent(item)}
            </div>
          )
        })}
      </Slide>
    ) : (
      <div></div>
    )
  }
}

export default SlideShowView
